// SnackbarComponent.js
import React, { useEffect, useState } from "react";
import { Snackbar, Alert } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { hideSnackbar } from "../../redux/slice/snackbar";
import SuccessSnack from "../../assets/images/SuccessSnack.svg";
import ErrorSnack from "../../assets/images/ErrorSnack.svg"; // Import the action
import WarningSnack from "../../assets/images/WarningSnack.svg";
import "./Snackbar.scss";
import { useLocation } from "react-router-dom";

const SnackbarComponent = () => {
  const dispatch = useDispatch();
  const { open, message, severity } = useSelector((state) => state.snackbar);
  const [hideSnack, setHideSnack] = useState(false);
  const handleClose = () => {
    dispatch(hideSnackbar());
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const authUser = useSelector((state) => state.auth.user);
  const rawUserEmail = authUser?.email || "";
  const token = "__cookie__";

  useEffect(() => {
    const missing = !rawUserEmail || !token;
    setHideSnack(missing);
  }, []);

  return (
    <>
      {!hideSnack && (
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          action={<button onClick={handleClose}>Close</button>}
          className="snackbar-for-toast-alert"
        >
          <Alert
            onClose={handleClose}
            className="snackbar-alert"
            sx={{ width: "100%", display: "flex", alignItems: "center" }}
          >
            {severity === "success" && (
              <img
                src={SuccessSnack}
                alt="success-snack"
                style={{ width: "24px", height: "24px", marginRight: "8px" }}
              />
            )}
            {severity === "error" && (
              <img
                src={ErrorSnack}
                alt="success-snack"
                style={{ width: "24px", height: "24px", marginRight: "8px" }}
              />
            )}
            {severity === "warning" && (
              <img
                src={WarningSnack}
                alt="success-snack"
                style={{ width: "24px", height: "24px", marginRight: "8px" }}
              />
            )}
            <span>{message}</span>
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default SnackbarComponent;
